let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kvtv6")).then(() => parcelRequire('5Bvqf'));